<template>
  <div>
    <MemberLayout activeLink="order">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <FordaysBannerLogo />
          </div>
          <div v-if="!checkEnabled" class="col-12 text-center mt-4">
            <h3><i class="fas fa-spinner fa-spin"></i> 載入中請稍候</h3>
          </div>
          <div v-if="checkEnabled" class="col-12">
            <button @click="enterRegular" class="member-main-btn">
              <i class="fas fa-credit-card"></i>
              <span class="member-main-btn-text">定期</span>
            </button>
          </div>
          <div v-if="checkEnabled" class="col-12">
            <button
              @click="enterAdditional"
              to="/member/additional-order"
              class="member-main-btn"
            >
              <i class="fas fa-credit-card"></i>
              <span class="member-main-btn-text">加購</span>
            </button>
          </div>
          <div v-if="checkEnabled" class="col-12">
            <router-link to="/member/record-list" class="member-main-btn">
              <i class="fas fa-th-list"></i>
              <span class="member-main-btn-text">訂購紀錄查詢</span>
            </router-link>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import MemberLayout from "../../components/member/MemberLayout";
import FordaysBannerLogo from "../../components/member/FordaysBannerLogo";
import { getCurrentUser } from "../../api/fordaysHelpers";
import db from "../../api/db";
export default {
  name: "OrderMainScreen",
  components: {
    MemberLayout,
    FordaysBannerLogo,
  },
  data() {
    return {
      ACT: -1,
      additionalOrderEnabled: false,
      regularOrderEnabled: false,
      checkEnabled: false,
    };
  },
  methods: {
    enterRegular() {
      const vm = this;
      if (!vm.regularOrderEnabled) {
        alert("定期功能現正維護中未開放使用");
        return;
      }
      if (vm.ACT == -1) {
        alert("訂期狀態確認中，請稍候");
        return;
      }
      if (vm.ACT == 1) {
        alert("您已完成本月定期購買");
        return;
      }
      vm.$router.push("/member/regular-order");
    },
    enterAdditional() {
      const vm = this;
      if (!vm.additionalOrderEnabled) {
        alert("加購功能現正維護中未開放使用");
        return;
      }
      if (vm.ACT == -1) {
        alert("加購狀態確認中，請稍候");
        return;
      }
      if (vm.ACT == 0) {
        alert("您必須先完成本月定期購買才可加購");
        return;
      }
      vm.$router.push("/member/additional-order");
    },
  },
  mounted() {
    const vm = this;
    async function fetchData() {
      const user = await getCurrentUser();
      vm.ACT = user.ACT;
      const purchaseStatusDoc = await db
        .doc(`publicConfigs/purchaseStatus`)
        .get();
      const purchaseStatus = purchaseStatusDoc.data();
      const { webAdditionalOrderEnabled, webRegularOrderEnabled } =
        purchaseStatus;
      vm.additionalOrderEnabled = webAdditionalOrderEnabled;
      vm.regularOrderEnabled = webRegularOrderEnabled;
      vm.checkEnabled = true;
    }
    fetchData();
  },
};
</script>